module.exports = __webpack_public_path__ + "media/images/istae-99d0622eb980dfa0789b2978c770751a.png";